/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2021, 2022
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import { createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import { ApiStatus } from '../../../../ts';
import { SystemDataTypesSlice } from '../../../../ts/state';
import { entityAdapter } from './adapter';
import listReducers from './ducks/list';

// initial state
const initialState: SystemDataTypesSlice = entityAdapter.getInitialState({
  listStatus: ApiStatus.IDLE, // idle, pending, fulfilled, error
  listFetched: null,
  listError: null
});

/**
 * Gets the initial state of the redux slice and apply updates.
 * @param {*} updates The updates to apply to the initial state
 * @returns {*} The slice initial state
 */
export const computeState = (updates: any): SystemDataTypesSlice => ({
  ..._.cloneDeep(initialState),
  ...updates
});

// Slice + Reducer
const slice = createSlice({
  name: 'systemDataTypes',
  initialState,
  reducers: {},
  extraReducers: {
    ...listReducers
  }
});

export const reducer = slice.reducer;
